import { setUserFavorite, unsetUserFavorite, types } from '../../users'
import notifications, {
  toastFailure,  toastSuccess
} from '../../../../global/notifications'

export default (dispatch) => ({
  setFavorite(objectUrl) {
    dispatch(setUserFavorite({ favorited_object: objectUrl })).then(
      ([_, res]) => {
        if (res.type === types.USERS_FAVORITE_SET_SUCCESS)
          toastSuccess(notifications.favoriteAdded)
        else
          toastFailure(notifications.favoriteAdded, res.payload)
      }
    )
  },
  unsetFavorite(pk) {
    dispatch(unsetUserFavorite(pk)()).then(([_, res]) => {
      if (res.type === types.USERS_FAVORITE_UNSET_SUCCESS)
        toastSuccess(notifications.favoriteRemoved)
      else
        toastFailure(notifications.favoriteRemoved, res.payload)
    })
  }
})
